import React, { useRef, useState, useEffect } from "react";
import DownArrowIcon from "../../icons/dashboard/ArrowDown";
import SearchIcon from "../../icons/dashboard/Search";
import SingleTick from "../../icons/dashboard/Single";
import useOutsideClick from "hooks/useOutsideClick";
import CustomTooltip from "./CustomTooltip";
import { InfoIcon } from "icons/payments/InfoIcon";

interface InputSelectProps {
  isCapitalize?: boolean;
  isAi?: boolean;
  labelPlaceHolder?: string;
  img?: string;
  type?: string;
  error?: boolean;
  value?: string;
  name?: string;
  label?: string;
  placeholder?: string;
  noLabel?: boolean;
  onChange?: any;
  onBlur?: any;
  disabled?: boolean;
  height?: string;
  fontSize?: string;
  defaultValue?: string;
  options?: any;
  selected?: any;
  setSelected?: any;
  isSearchFeature?: boolean;
  searchFieldType?: string;
  isUpDropDown?: boolean;
  isRounded?: boolean;
  paddingY?: string;
  isSmall?: boolean;
  isbottom?: boolean;
  makePayment?: boolean;
  maxHight?: string;
  disabledList?: any;
  isInfoAvailable?: boolean;
  infoText?: string | null;
  infoClassName?: string;
  isSelectedOffer?: boolean | false;
}

const InputSelect = ({
  isCapitalize = false,
  isAi = false,
  labelPlaceHolder = "",
  img = "",
  type = "",
  error,
  value = "",
  name = "name",
  label = "label",
  placeholder = "Placeholder",
  noLabel = false,
  disabled = false,
  height = "",
  fontSize = "",
  options = [],
  selected,
  setSelected,
  isSearchFeature = false,
  searchFieldType = "text",
  isUpDropDown = false,
  isRounded = false,
  paddingY = "",
  isSmall = false,
  isbottom = false,
  makePayment,
  maxHight,
  disabledList,
  isInfoAvailable = false,
  infoText = null,
  infoClassName = "",
  isSelectedOffer = false,
}: InputSelectProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [query, setQuery] = useState("");
  const dropDownRef = useRef<any>();
  const isControlDisabled = disabled || isSelectedOffer;
  useOutsideClick(dropDownRef, () => setIsOpen(false));

  useEffect(() => {
    if (isControlDisabled) {
      setIsOpen(false);
      setQuery("");
    }
  }, [isControlDisabled]);

  useEffect(() => {
    if (makePayment) {
      const fixedOption = options.find(
        (option: any) => option.value === "fixed"
      );
      // Some make-payment selects (for example, transaction percentages) do
      // not have a "fixed" option. Do not emit an undefined selection: their
      // handlers coerce it to zero and overwrite a valid transaction amount.
      if (fixedOption) {
        setSelected(fixedOption);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [makePayment]);

  const filteredOptions =
    query === ""
      ? options
      : options.filter((person: any) => {
          const nameStr = String(person?.name ?? "");
          const qStr = String(query ?? "");
          return nameStr
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(qStr.toLowerCase().replace(/\s+/g, ""));
        });

  return (
    <>
      <div ref={dropDownRef} className="relative">
        <div className="absolute bottom-[-24px] text-xs text-red-400">
          {error}
        </div>
        {!noLabel && (
          <div
            className={`mb-[3px] leading-[15.62px] flex gap-[3px] items-center justify-start`}
          >
            <p className="uppercase text-xs font-bold text-txtSecondary ">
              {label}
            </p>
            {isInfoAvailable && infoText && (
              <CustomTooltip
                maxwidth="430px"
                place="top"
                id={`${label}-anchor`}
                content={`<div class="text-xs leading-[18px] font-normal ${infoClassName}">${infoText}</div>`}
              >
                <InfoIcon
                  id={`${label}-anchor`}
                  strokeColor="var(--color-icon-bright)"
                  className="cursor-pointer group"
                  _className="group-hover:!stroke-iconObscure"
                />
              </CustomTooltip>
            )}
          </div>
        )}

        <div
          onClick={() => {
            if (!isControlDisabled) {
              setIsOpen(!isOpen);
            }
          }}
          aria-disabled={isControlDisabled}
          style={{
            borderRadius: isRounded ? "20px" : "",
            fontSize: fontSize ? fontSize : "",
            height: height ? height : "40px",
            paddingBlock: paddingY ? paddingY : "",
          }}
          className={`text-txtPrimary relative capitalize focus-visible:none bg-white focus-visible:outline-none flex items-center w-full ${isControlDisabled ? "cursor-not-allowed !bg-bgThird !border-strokePrimary !text-txtSecondary" : "cursor-pointer"} ${isbottom ? "rounded-t-[7px]" : "rounded-[7px]"} bg-moon-white ${isSmall ? "px-[8px]" : "px-[15px]"}   text-sm  ${
            error ? "border-red" : "border-strokePrimary"
          } ${isControlDisabled ? "" : "hover:!border-strokeActive"} border-[1px] pr-[30px] placeholder-txtSecondary`}
        >
          {disabled
            ? String(value ?? "").toLowerCase()
            : selected?.name
              ? isCapitalize
                ? String(selected?.name ?? "").toLowerCase()
                : String(selected?.name ?? "")
              : labelPlaceHolder}{" "}
          {}
          <span
            className={`absolute right-[12px] ${
              isSmall ? "h-[12px] w-[12px]" : "h-[16px] w-[16px]"
            } ${isControlDisabled ? "opacity-40" : ""} ${!isOpen ? "rotate-[360deg]" : "rotate-180"}`}
          >
            {/* The closed state always points down, even when the list itself
                opens upward for the bottom rows. */}
            <DownArrowIcon />
          </span>
        </div>
        {/* OPTIONS */}
        {isOpen && !isControlDisabled && (
          <div
            className={`absolute w-full bg-white shadow-md ${
              isUpDropDown
                ? "bottom-[calc(100%-18px)]"
                : `${
                    isAi
                      ? "top-[27px]"
                      : `${maxHight ? "top-[40px]" : "top-[63px]"}`
                  }`
            } max-h-[260px] ${
              maxHight ? "overflow-y-scroll" : "overflow-y-clip"
            } rounded-[7px] z-50 border-strokePrimary border-[1px]  ${maxHight && maxHight}`}
          >
            {isSearchFeature && (
              <div className="flex items-center overflow-hidden focus-visible:none bg-white focus-visible:outline-none h-[40px] w-full rounded-t-[7px] bg-moon-white px-[13px] py-[7px] text-sm border-strokePrimary border-b-[1px]">
                <span className="w-[18px] h-[18px] cursor-pointer">
                  <SearchIcon />
                </span>
                <input
                  type={searchFieldType}
                  value={value}
                  disabled={disabled}
                  placeholder="Search"
                  onChange={(e) => {
                    setQuery(e.target.value);
                  }}
                  style={{ fontSize: fontSize ? fontSize : "" }}
                  className={`focus-visible:none bg-white focus-visible:outline-none h-full ${
                    isbottom ? "rounded-t-[7px]" : "rounded-[7px]"
                  }  bg-moon-white pl-[6px] grow text-[15px] placeholder-txtSecondary`}
                />
              </div>
            )}
            <div
              className={`${
                isSearchFeature && "max-h-[220px] h-auto overflow-y-auto"
              }`}
            >
              {filteredOptions.map((itm: any, index: number) => {
                return (
                  <div
                    key={index}
                    style={{
                      fontSize: fontSize ? fontSize : "",
                    }}
                    className={`flex justify-between px-[15px] text-sm py-[6px] hover:!bg-dropdownbg ${
                      isControlDisabled ||
                      itm?.isdisabled ||
                      disabledList?.includes(itm?.value)
                        ? "cursor-not-allowed text-strokePrimary"
                        : "cursor-pointer text-txtPrimary"
                    }`}
                    onClick={() => {
                      if (
                        !isControlDisabled &&
                        !itm?.isdisabled &&
                        !disabledList?.includes(itm?.value)
                      ) {
                        setIsOpen(false);
                        setSelected(itm);
                        setQuery("");
                      }
                    }}
                  >
                    <div className="flex items-center gap-[7px]">
                      {itm?.img && (
                        <img
                          src={itm?.img}
                          alt="img"
                          className="h-[16px] w-[16px]"
                        />
                      )}
                      <div
                        className={`${
                          selected?.name === itm?.name
                            ? "font-medium"
                            : "font-normal"
                        }`}
                      >
                        {itm?.name}
                      </div>
                    </div>
                    {selected?.name === itm?.name && (
                      <>
                        <span className="w-[12px] h-[9px] flex self-center">
                          <SingleTick />
                        </span>
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default InputSelect;
